module.exports = __webpack_public_path__ + "img/10.91c124ca.svg";